import { getGenericEndpoint } from './get.api';
import type { GetFullRegisterResponse } from './types';

export const getFullRegister = async (lang?: string) => {
	return await getGenericEndpoint<GetFullRegisterResponse>(
		'register/full',
		lang
	);
};
